<template>
<v-container id="change-password" pa-0>
  <v-dialog persistent v-model="changePasswordDialog">
    <v-card color="rgba(255, 255, 255, 0.7)" class="border-radius-15 modal-class">
      <v-container id="root-dialog" pa-0>
        <v-layout id="fdi-login-form" column justify-center>
          <v-flex mt-3 mx-3>
            <h1 class="text-xs-center">CHANGE Your PASSWORD</h1>
          
            <h5 class="text-xs-center prestige">Password Criteria:<ol class="text-xs-left mt-1"><li>Must be 8 or more characters</li><li>Must have at least 1 uppercase character</li><li>Must have at least 1 Number</li></ol></h5>
          </v-flex>
          <v-flex xs12 d-flex justify-center align-center>
            <v-flex xs12 sm6 md4>
              <v-alert my-0 py-0 v-if="error" value="error" type="error">
                {{ error }}
              </v-alert>
              <v-alert my-0 py-0 v-else-if="successMsg" value="successMsg" type="success">
                {{ successMsg }}
              </v-alert>
              <div id="error-spacer" v-else>

              </div>
            </v-flex>
          </v-flex>

          <v-flex class="prestige" xs12 d-flex justify-center align-center>
            <v-flex xs9 md4>
              <v-text-field @keyup.enter.stop.prevent v-model="newpassword" single-line label="NEW PASSWORD">
              </v-text-field>
              <v-text-field @keyup.enter.stop.prevent v-model="newpassword2" single-line label="RETYPE">
              </v-text-field>
            </v-flex>
          </v-flex>

        </v-layout>
      </v-container>
      <v-card-actions class="my-3">
        <v-spacer></v-spacer>
        <v-btn flat @click="backToSignIn">
          <v-img :src="backButton" />
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn block large outline color="black" class="button-border" flat :disabled="newpassword !== newpassword2 || newpassword === ''" @click="updatePassword">submit</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

  </v-dialog>
</v-container>
</template>

<script>
import { Auth, JS } from "aws-amplify";

import backButtonBlk from "@/assets/buttons/back-blk.png";
import { setTimeout } from "timers";

export default {
  name: "ChangePassword",
  data() {
    return {
      newpassword: "",
      newpassword2: "",
      user: null,
      error: null,
      successMsg: null,
      changePasswordDialog: true,
      backButton: backButtonBlk
    };
  },
  computed: {},
  methods: {
    updatePassword: function(event) {
      this.$store.dispatch("updateTempUser", {
        newPassword: this.newpassword
      });
      let cognitoUser = this.$store.getters.tempCognitoUser;
      console.log(cognitoUser);
      Auth.completeNewPassword(cognitoUser, this.newpassword)
        .then(user => {
          this.$store.dispatch("setUser", user);
          this.successMsg = "You have successfully changed your password!";
          this.$store.dispatch("setTempUser", null);
          this.$store.dispatch("setTempCognitoUser", null);

          setTimeout(() => {
            this.$router.push("/");
          }, 1500);
        })
        .catch(err => {
          this.setError(err);
        });
    },
    backToSignIn: function() {
      this.$router.push("/auth/signIn");
    },
    setError: function(err) {
      this.error = err.message || err;
    }
  }
};
</script>

<style scoped>
</style>

<style>
#change-password {
  height: 100%;
  background-image: url("../../../assets/paper_bkgd.png");
  background-size: cover;
  background-position: center;
  font-family: "BebasNeueRegular";
}

.prestige {
  font-family: "PrestigeElite-STD";
}

#error-spacer {
  height: 75px;
}

#bottom-button-container {
  height: 44px;
}

#fdi-login-form .v-text-field__slot label {
  text-align: center;
  width: 100%;
  margin-left: 10px;
}

#fdi-login-form .v-text-field__slot input {
  border-bottom: 2px solid black;
  padding-bottom: 1px;
}

#fdi-login-form .v-text-field__slot input:active {
  border-bottom: 2px solid blue;
}

#login-footer {
  justify-content: "flex-end";
}
</style>
